import { Box, Divider, useTheme } from "@mui/material";
import Header from "../../../Layout/Header";
import { useState, useTransition } from "react";
import WinderActionMenu from "./ActionMenu";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import ParentRollAndShiftDetail from "./ParentRollShift";
import { tokens } from "../../../theme/theme";
import MOAndMADetailTable from "./MOAndMADetailTable";
import { useCombinationDetails } from "../../../hooks/winderprocess/useCombinationDetails";
// import { useWinderCombinationDetails } from "../../../hooks/winderprocess/useWinderCombinationDetails";

const AddWinderProcess = ({ editPartyID, callback }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTransition();

    // Rejection Dialog State
    const userId = localStorage.getItem('userID');
    const [enableRejectParentRoll, setEnableRejectParentRoll] = useState(false);
    const [isRejectionDialogOpen, setIsRejectionDialogOpen] = useState(false);

    const [selectedButtonName, setSelectedButtonName] = useState('');

    // ma mo details update 
    const [lotsDetail, setLotsDetail] = useState([]);
    const [selectedLot, setSelectedLot] = useState([]); // selected lot for create job and edit process
    const [selectedParentRollLot, setSelectedParentRollLot] = useState([]); // check ma reel length
    const [noLength, setNoLength] = useState(false);

    // selected ma mo details
    const [availableSetLength, setAvailableSetLength] = useState(0);
    const [setLength, setSetLength] = useState(0);
    const [actualSetLength, setActualSetLength] = useState(0);
    const [gsm, setGSM] = useState(0);
    const [selectedCore, setSelectedCore] = useState(0);
    const [achievedDeckleValue, setAchievedDeckleValue] = useState(0);
    const [jumboValue, setJumboValue] = useState(0);

    // // hooks
    // const { selectedCombination, availableLot, selectedSetID, combinationStatus, isExtraSetModalOpen, loading, error, getParticularCombinationDetails, } = useCombinationDetails(actualSetLength);


    const handlecallProcess = (buttonName) => {
    };

    // choose parent roll number then trigger to load involved ma and mo details here       
    const handleEditLot = (row) => {
        // handleEdit(row);
        setSelectedLot(row);

        if (row.reel_length) {
            setSelectedParentRollLot([row]);
            setNoLength(false);
        }
        else {
            setSelectedParentRollLot([]);
            setNoLength(true);
        }
    };


    const handleEdit = () => {

    }

    //
    const columns = [
        { headerName: "S.NO", field: "id" },
        { headerName: "PARENT ROLL #", field: "pr_number" },
        { headerName: "MO NUMBER", field: "release_no" },
        { headerName: "MA NUMBER", field: "lot_no", type: "number", align: "right" },
        { headerName: "TOTAL SETS", field: "set_no", type: "number", align: "right" },
        { headerName: "PLANNED QUANTITY", field: "planned_qty", type: "number" },
        { headerName: "BALANCE QUANTITY", field: "ma_qty", type: "number" },
        { headerName: "PLANNED LENGTH", field: "planned_length", type: "number" },
        { headerName: "BALANCE LENGTH", field: "reel_length", type: "number" },
        { headerName: "REMARKS", field: "remarks" },
    ];


    // edit mo ma detail changes
    const handleEditClickAll = (row) => {
        setSelectedLot(row);
    }




    return (
        <Box>
            <Header title={editPartyID === 0 ? 'Add New Winder Job' : 'Edit Winder Job'} subtitle="" callback={callback} />
            <Divider />
            {editPartyID !== 0 && (<>
                <WinderActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} enableRejectParentRoll={enableRejectParentRoll} />
                <Divider />
            </>)}

            <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>
                <ParentRollAndShiftDetail handleEdit={handleEditLot} setLotsDetail={setLotsDetail} editLot={selectedLot} />
                <MOAndMADetailTable colors={colors} rows={lotsDetail} columns={columns} onEdit={(row) => handleEditClickAll(row)} />
            </ResponsiveBox>
        </Box>
    )
}
export default AddWinderProcess;